import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    CircularProgress,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import StatsSummary from 'components/StatsSummary'
import { findMostRecentDate } from 'utils/findMostRecentDate'
import { formatDate } from 'utils/formatDate'
import styles from './styles.module.scss';
import { useJourneyTestCases } from 'pages/SingleJourney/queries/useJourneyQuery'
import EmptyJourney from '../EmptyJourney'
import AccordionChart from './components/AccordionChart'
import { TEST_CASE_STATUS } from '../TestCasesTab/constants'

const OverviewTab = (props) => {
    const { 
        journeyId, 
        expectedResult, 
        requirements
    } = props;

    const { data: journeyTestCasesResponse, isLoading: isTestCasesLoading } = useJourneyTestCases({ journeyId });

    const journeyTestCases = journeyTestCasesResponse?.testCases || [];

    const lastGeneratedDate = findMostRecentDate(journeyTestCases)
    const failedTotal = journeyTestCases.filter(testCase =>
        testCase.status === TEST_CASE_STATUS.failed ||
        testCase.status === TEST_CASE_STATUS.initialFailure
    ).length
    const passedTotal = journeyTestCases.filter(testCase => testCase.status === TEST_CASE_STATUS.completed).length
    const issueRate = journeyTestCases.length
        ? ((failedTotal / journeyTestCases.length) * 100).toFixed(2)
        : "0.00"


    if (isTestCasesLoading) return (
        <Box className={styles.loaderWrapper}>
            <CircularProgress />
        </Box>
    );

    if (!journeyId) return <EmptyJourney />

    return <Box className={styles.container}>
        {requirements && <Box className={styles.requirementsWrapper}>
             <span>Requirements:</span>
            <Typography>
                {requirements}
            </Typography>
        </Box>}
        {expectedResult && <Box className={styles.expectedWrapper}>
             <span>Expected Test Cases:</span>
            <Typography>
                {expectedResult}
            </Typography>
        </Box>}
        {journeyTestCases && journeyTestCasesResponse && (
            <Accordion className={styles.accordion} defaultExpanded>
                <AccordionSummary className={styles.summary} expandIcon={<ExpandMoreIcon />}>
                    <Typography className={styles.title}>Test Cases</Typography>
                </AccordionSummary>
                <AccordionDetails className={styles.details}>
                    <Box className={styles.statsSection}>
                        <StatsSummary title="Last Generated Test Cases Date" value={lastGeneratedDate ? formatDate(lastGeneratedDate) : '-'} color="primary" />
                        <StatsSummary title="Total Test Cases" value={journeyTestCasesResponse.total} color="primary" />
                        <StatsSummary title="Passed Test Cases" value={passedTotal} color="primary" />
                        <StatsSummary title="Failed Test Cases" value={failedTotal} color="primary" />
                        <StatsSummary title="Issue Rate" value={`${issueRate}%`} color={issueRate > 0 ? "#d32f2f" : "#198754"} />
                    </Box>
                    <AccordionChart testCasesData={journeyTestCases} />
                </AccordionDetails>
            </Accordion>
        )}
    </Box>
}

export default OverviewTab;
